import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

export type CreateSessionsRequest = { dateFrom: Date; dateTo: Date; name: string };

const create = (courseId: number, data: CreateSessionsRequest): AxiosPromise => {
  return api.post(endpoints.COURSES_SESSIONS.CREATE(courseId), { ...data, description: "" });
};

const update = (courseId: number, courseSessionId: number, body: MapEventsBody): AxiosPromise => {
  return api.put(endpoints.COURSES_SESSIONS.UPDATE(courseId, courseSessionId), body);
};

const fetchByCourseId = (courseId: number) => {
  return api.get<CourseSessionsResponse>(endpoints.COURSES_SESSIONS.GET(courseId));
};

const deleteSession = (courseId: number, sessionId: number): Promise<void> => {
  return api.delete(endpoints.COURSES_SESSIONS.DELETE(courseId, sessionId));
};

export const courseSessionsApi = {
  create,
  fetchByCourseId,
  update,
  delete: deleteSession,
};

interface MapEventsBody {
  name: string;
  newFromDate: Date;
  newToDate: Date;
  mappings: { from: string; to: string }[];
  trancheDueDates?: { trancheId: number; dueDate: Date }[];
}
export interface CourseSessionsResponse {
  data: CourseSessionApi[];
  isReady: boolean;
}

export interface CourseSessionApi {
  id: number;
  dateFrom: Date;
  dateTo: Date;
  name: string;
}
